const GET_TRANSFER_ORDER_BY_ID = 'GET_TRANSFER_ORDER_BY_ID';
const SET_TRANSFER_ORDER_BY_ID = 'SET_TRANSFER_ORDER_BY_ID';

const CREATE_TRANSFER_ORDER_REQUEST = 'CREATE_TRANSFER_ORDER_REQUEST'

export
{
    GET_TRANSFER_ORDER_BY_ID,
    SET_TRANSFER_ORDER_BY_ID,
    CREATE_TRANSFER_ORDER_REQUEST
};
